import React, { useState } from 'react'
import Button from '../../Button'
import { ButtonType } from '../../Button/types'
import { ProducersListProps, ProducersListSize } from './types'
import { PortalCustomerItem } from '../../../Services/CompanyInformations/interfaces'
import { useTranslation } from 'react-i18next'
import './Scss/producers-list.scss';

const ProducersList = (props: ProducersListProps) => {
    const { t } = useTranslation()
    const [size, setSize] = useState<number>(ProducersListSize.Default)

    const noResults = !!(!props.items || props.items.length === 0)

    const onToggleSize = () => {
        setSize(
            size === ProducersListSize.Default
                ? ProducersListSize.Expanded
                : ProducersListSize.Default
        )
    }

    return (
        <div className={'producers-list'}>
            <div className={'producers-list__header'}>
                <span>{t('connectedProducersListBlock.nameLabel')}</span>
                <span>
                    {t('connectedProducersListBlock.organisationNumberLabel')}
                </span>
            </div>
            {noResults && (
                <div className={'producers-list__no-results'}>
                    {t('connectedProducersListBlock.noResults')}
                </div>
            )}
            {props.items.map((item: PortalCustomerItem) => {
                if (props.isSearched || size > ProducersListSize.Default) {
                    return (
                        <div className={'producers-list__list-item'} key={item.id}>
                            <span className="name">{`${item.name}`}</span>
                            <span className="org-no">{`${item.orgNo ??
                                item.vatNo ??
                                ''}`}</span>
                        </div>
                    )
                }
                return null
            })}
            {!props.isSearched && props.items?.length > 0 && (
                <div className={'producers-list__button'}>
                    <Button
                        type={ButtonType.PRIMARY_ALT}
                        text={t('connectedProducersListBlock.showAll')}
                        onClick={onToggleSize}
                    />
                </div>
            )}
        </div>
    )
}

export default ProducersList
